import React from 'react';
import GoogleMapReact, { Coords } from 'google-map-react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Icon from '@material-ui/core/Icon';
// import Input from '@material-ui/core/Input';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Select from '@material-ui/core/Select';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, RouteComponentProps, match } from 'react-router-dom';

// Components
import { ActionLogs } from '../../../components/action-logs';
import { Anchor } from '../../../components/anchor';
import Comment from '../../../components/comment/comment';
import App from '../../../components/app';
// import { ActionCustom, ActionFunction } from '../../../local-types';
import { Dialog } from '../../../components/dialog';
// import { AutoFill } from '../../../components/field-autofill';
//
import EnhancedListItem from '../../../components/listItem';
import MainLoading from '../../../components/main-loading';
import MyLink from '../../../components/mylink';
import EnhancedTable from '../../../components/table';
import { TooltipButton } from '../../../components/tooltip-button';
import { Typobold } from '../../../components/typobold';
import FastTabs, { TabsDatas } from '../../../components/tabs/tabs';
import { InlineDocument } from '../../../components/inlineDocument';
import ErrorMessage from '../../../components/error-message';
import FidForm from '../fid/fid-form';
import FormSubmit from '../../../components/form/formSubmit';
// Modules
import {
    actions as companyActions,
    CompanyById,
    selectors as companySelector,
    types as companyTypes,
} from '../../../redux/reducers/companies';
import {
    Company,
    GroupPricingSet,
    Price,
    PricingSet,
    Service,
    CompanyCentralizedPayment,
    CompanyCentralizedPaymentMode,
    CompanyMensualCentralizedPaymentMode,
    DispatchGroup,
    DocumentType,
    TParams,
    TravelPolicyTimeSlot,
} from '../../../redux/reducers/api-types';
import { actions as driversActions, selectors as driversSelectors } from '../../../redux/reducers/drivers';
import {
    actions as pricingActions,
    selectors as pricingSelectors,
    types as pricingTypes,
} from '../../../redux/reducers/pricing';
import { actions as errorActions, ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import styles from './company-view-style';
import FormattingUtils from '../../../utils/formattingUtils';
import withGlobalStyles from '../../../utils/global-styles';
import ObjectUtils from '../../../utils/objectUtils';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import DateUtils from '../../../utils/dateUtils';
import MapUtils from '../../../utils/mapUtils';
import { paths, createPath } from '../../paths';
import { EntityName } from '../../../redux/reducers/generic';
import { TableRequestPoint } from '../../../redux/reducers/table';
import { forceBillingGroups } from '../../../utils/constants';
import { generateDocumentUrl, getCostCenterDetails, getPaymentModeDetails } from '../../../utils/businessUtils';
import StringUtils from '../../../utils/stringUtils';
import { clsx } from '../../../utils/htmlUtils';
import { FormatType, HeadCell, ListCell } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';
import envConfig from '../../../config';

export const STOP_TYPE_COLOR = {
    all: { label: 'Pickup & Dropoff', strokeColor: '#0000FF', fillColor: '#3244CD' },
    PICKUP: { label: 'Pickup', strokeColor: '#00FF00', fillColor: '#9ACD32' },
    DROP_OFF: { label: 'Dropoff', strokeColor: '#FF0000', fillColor: '#CD3232' },
};

interface DispatchGroupAuthorization {
    id: string;
    name: string;
    isEnabled: boolean; // Controls if visible in BO
    isAuthorized: boolean; // Controls if authorized for company
}

interface CompanyViewPageProps extends WithStyles, WithTranslation, RouteComponentProps {
    match: match<TParams>;
    globalClasses: any;
    center: Coords;
    zoom: number;
    getCompanyError: ErrorPayload;
    companyViewActionsError: ErrorPayload;
    clearError: (errorType: string) => void;
    getIndustriesError: ErrorPayload;
    getTravelPoliciesError: ErrorPayload;
    updateGroupPricingSetsError: ErrorPayload;
    isLoadingTravelPolicy: boolean;
    prices: Price[];
    services: Service[];
    companies: CompanyById;
    dispatchGroups: DispatchGroup[];
    getCompany: (id: string) => any;
    getCompanyReport: (id: string) => any;
    exportCompanyTrips: (id: string, params?: any) => any;
    exportCompanyUsers: (id: string) => any;
    forceBillRides: (groupdId: string) => any;
    editMember: (id, idm, payload, type, callback?) => any;
    deleteContract: (id, payload, callback) => any;
    deleteCompany: (id: string, parentId: string) => any;
    banDriverFromCompany: (id, idc, callback) => any;
    unbanDriverFromCompany: (id, idc, blacklistId) => any;
    getTravelPolicies: (uuid, id, parentUuid?) => any;
    getDispatchGroups: () => any;
    editCompany: (id, payload) => any;
    editCompanyDispatchGroups: (id, payload, callback) => any;
    getCompanyToExtras: () => any;
    deleteCompanyToExtras: (id, ide) => any;
    getCompanyToPricingSets: () => any;
    createCompanyToExtras: (company, payload, callback) => any;
    deleteCompanyToPricingSets: (id, idp, idc) => any;
    getPricingSets: () => any;
    getServices: () => any;
    createGroupToPricingSets: (idc, pricing_set, payload, callback?) => any;
    deleteGroupToPricingSets: (id, idp, idc) => any;
}

interface CompanyViewPageState {
    text: string;
    idc: any;
    formData: {
        id?: string;
        dispatchGroups: DispatchGroupAuthorization[];
        initialDispatchGroups?: DispatchGroupAuthorization[];
    };
    formSms: any;
    /** Per-company `subcontract_hide_rider`: local copy of the checkbox until it is validated. */
    formSubcontract: { hideRider: boolean };
    extra: any;
    groupPricingSetId: string;
    groupStartDate: string;
    groupEndDate: string;
    myBounds: any;
    dialogVisible: boolean;
}

class CompanyViewPage extends React.Component<CompanyViewPageProps, CompanyViewPageState> {
    static defaultProps = {
        center: MapUtils.defaultCenter,
        zoom: MapUtils.defaultZoom,
    };

    map: any;
    maps: any;
    defaultBounds: any;

    autofillRef: any;

    tableMembersRef: any;
    tableContractsRef: any;
    tableDepartmentsRef: any;
    tableRequestPoints: any;
    statusOptions: any[];
    contactStatusOptions: any[];
    departmentOptions: any[];

    canWriteSettings: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_SETTINGS,
        mode: RightRank.W,
    });

    canExport: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_EXPORT,
        mode: RightRank.W,
    });

    canReadPricing: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_PRICING,
        mode: RightRank.R,
    });
    canWritePricing: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_PRICING,
        mode: RightRank.W,
    });

    // Guards loadPricingCatalogue: componentDidUpdate fires on every render.
    pricingCatalogueRequested: boolean = false;

    canCreateGroupSheet: boolean = UserUtils.checkRights([
        { name: AccountRight.PRICING_MGMT, mode: RightRank.W },
        { name: AccountRight.COMPANY_PRICING, mode: RightRank.W },
    ]);

    canReadFid: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_FID_PROGRAM,
        mode: RightRank.R,
    });

    constructor(props: CompanyViewPageProps) {
        super(props);
        this.state = {
            text: '',
            idc: -1,
            formData: {
                dispatchGroups: [],
            },
            extra: '',
            groupPricingSetId: '',
            groupStartDate: '',
            groupEndDate: '',
            formSms: { disabled: false },
            formSubcontract: { hideRider: true },
            myBounds: null,
            dialogVisible: false,
        };
        const { match, t } = this.props;
        const id = match.params.id;
        this.statusOptions = [
            {
                value: '',
                label: '',
            },
            {
                value: 'confirmed',
                label: t('memberships.status_confirmed'),
            },
            {
                value: 'pending',
                label: t('memberships.status_pending'),
            },
            {
                value: 'ended',
                label: t('memberships.status_ended'),
            },
            {
                value: 'rejected',
                label: t('memberships.status_rejected'),
            },
        ];

        this.contactStatusOptions = [
            {
                value: '',
                label: '',
            },
            {
                value: 'created',
                label: t('document:status.created'),
            },
            {
                value: 'signing',
                label: t('document:status.signing'),
            },
            {
                value: 'pending',
                label: t('document:status.pending'),
            },
            {
                value: 'active',
                label: t('document:status.active'),
            },
            {
                value: 'terminated',
                label: t('document:status.terminated'),
            },
        ];
        this.tableRequestPoints = this.getCurrentTableRequestPoints(id);
    }

    componentDidMount() {
        this.load();
    }

    load = (): void => {
        // A failure recorded for the entity we come from would otherwise greet the next
        // one with the retry panel instead of the loader.
        this.props.clearError(companyTypes.GET_COMPANY);

        const { match, companies, dispatchGroups } = this.props;
        const id = match.params.id;
        const company = companies[id];

        if (!company) {
            this.loadDatas(id);
        }

        if (dispatchGroups.length === 0) {
            this.props.getDispatchGroups();
        }

        this.loadPricingCatalogue(company);
    };

    /**
     * The sheet catalogue backs the attach picker, and only a departement has
     * one. Fetching it for every company page would pull the whole pricing set
     * list on pages that never show it.
     */
    loadPricingCatalogue = (company?: Company) => {
        if (this.pricingCatalogueRequested || !company?.parent || !this.canWritePricing) {
            return;
        }
        this.pricingCatalogueRequested = true;
        this.props.getPricingSets();
        this.props.getServices();
    };

    static getDerivedStateFromProps(props: CompanyViewPageProps, state) {
        const { match, companies, dispatchGroups, getTravelPolicies } = props;
        const id = match.params.id;
        const payload: any = companies[id];
        if (payload && dispatchGroups.length > 0 && (!state.formData.id || String(state.formData.id) !== id)) {
            // Transform dispatch groups into simpler structure
            const transformedGroups: DispatchGroupAuthorization[] = dispatchGroups.map((group) => {
                const existingAuth = payload.dispatch_group_authorizations.find((d) => d.id === group.id);
                return {
                    id: group.id,
                    name: group.name,
                    isEnabled: existingAuth ? existingAuth.status_bo : group.defaultAvailable,
                    isAuthorized: existingAuth ? existingAuth.status : group.defaultAvailable,
                };
            });

            // Store both current and initial state
            Object.assign(payload, {
                dispatchGroups: transformedGroups,
                initialDispatchGroups: JSON.parse(JSON.stringify(transformedGroups)),
            });

            // Ride manager
            getTravelPolicies(payload.uuid, id, payload.parent?.uuid);

            return {
                formData: payload,
                formSms: { disabled: !payload.reservation_sms },
                formSubcontract: { hideRider: !!payload.subcontract_hide_rider },
            };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.id !== (this.props.match.params as any).id) {
            const id = this.props.match.params.id;
            this.loadDatas(id);

            this.tableRequestPoints = this.getCurrentTableRequestPoints(id);
        }

        // The company arrives after mount, so this is the first point at which
        // we know whether the page is a departement at all.
        this.loadPricingCatalogue(this.props.companies[this.props.match.params.id]);
    }

    getCurrentTableRequestPoints(id): { [id: string]: TableRequestPoint } {
        return {
            COMPANIES_DEPARTMENTS: {
                preload: true,
                url: `companies/${id}/departments`,
                reducer: 'companies_departments',
                handleRow: (rowId) => `/companies/${rowId}`,
            },
            COMPANIES_MEMBERSHIPS: {
                preload: true,
                url: `companies/${id}/memberships`,
                reducer: 'companies_memberships',
                handleRow: (rowId) => `/riders/${rowId}`,
            },
            COMPANIES_CONTRACTS: {
                preload: true,
                url: `companies/${id}/contracts`,
                reducer: 'companies_contracts',
            },
        };
    }

    //======================================//
    //=============== Method ===============//
    //======================================//

    loadDatas(id) {
        this.props.getCompany(id);
    }

    //===================================//
    //=============== MAP ===============//
    //===================================//

    handleApiLoaded = (map, maps): void => {
        this.map = map;
        this.maps = maps;

        const { match, companies, center } = this.props;
        const id = match.params.id;
        const company = companies[id];

        this.defaultBounds = MapUtils.getBounds(maps, [center]);

        if (company.travel_policies?.areas?.length > 0) {
            const bounds = new maps.LatLngBounds();
            company.travel_policies.areas.forEach((a) => {
                const colors = STOP_TYPE_COLOR[a.stop_type] ?? STOP_TYPE_COLOR.all;
                const newCircle = MapUtils.generateCircle(
                    maps,
                    +a.latitude,
                    +a.longitude,
                    +a.radius,
                    colors.strokeColor,
                    colors.fillColor,
                );
                newCircle.setMap(map);
                MapUtils.extendCircleBounds(maps, bounds, +a.latitude, +a.longitude, +a.radius);
            });
            // map.fitBounds(bounds);
            this.defaultBounds = bounds;
            this.setState({ myBounds: bounds });
        }
    };

    //=============================================//
    //=============== Event Handler ===============//
    //=============================================//

    handleCompaniesRow(id) {
        this.props.history.push(`${paths.companies}/${id}`);
    }

    handleUsersRow(id) {
        this.props.history.push(`${paths.riders}/${id}`);
    }

    handleAction = (obj: any, status: string) => () => {
        const id = this.props.match.params.id;

        if (status === companyTypes.DELETE_COMPANY_CONTRACT) {
            this.props.deleteContract(obj.id, { state: 'terminated' }, () => {
                this.tableContractsRef.reload();
            });
        }
        if (status === pricingTypes.DELETE_COMPANY_PRICING_SET) {
            this.props.deleteCompanyToPricingSets(obj.id, obj.company_to_pricing_set_id, id);
        }
        if (status === pricingTypes.DELETE_GROUP_PRICING_SET) {
            this.props.deleteGroupToPricingSets(obj.id, obj.group_to_pricing_set_id, id);
        }
        if (status === pricingTypes.DELETE_COMPANY_EXTRA) {
            this.props.deleteCompanyToExtras(id, obj.company_to_extra_id);
        }
    };

    handleUserUpdate(type, obj, params) {
        if (this.canWriteSettings) {
            const { match } = this.props;
            const id = match.params.id; // id company
            const idm = obj.rider.id; // id member
            this.props.editMember(id, idm, params, type);
        }
    }

    handleContractUpdate = (obj, params) => {
        if (this.canWriteSettings) {
            const id = obj.id; // id document

            //deleteContract ne fait que changer le status du contrat
            //We put the value in the actual awaited param
            params.state = params['current_version.state'];
            this.props.deleteContract(id, params, () => {
                this.tableContractsRef.reload();
            });
        }
    };

    handleDeleteCompany(id, parentId) {
        this.props.deleteCompany(id, parentId);
    }

    /**
     * The sheets this departement may be given.
     *
     * Mirrors the server rule: a sheet may be attached to a group only if it,
     * or one of its ancestors, is attached to the company that owns the group.
     * pricing_sets already holds exactly that company's sheets - the payload
     * flattens a departement to its parent - so the chain is walked against it.
     *
     * The server is the authority; this only keeps sheets the server would
     * refuse out of the picker.
     */
    groupSheetCandidates = (payload: Company): Price[] => {
        const { prices } = this.props;
        const companySheetIds = new Set((payload.pricing_sets ?? []).map((x) => x.id));
        if (!prices?.length || companySheetIds.size === 0) {
            return [];
        }

        const byId = new Map(prices.map((p) => [p.id, p]));
        const alreadyAttached = new Set((payload.group_pricing_sets ?? []).map((x) => x.id));

        return prices.filter((sheet) => {
            if (alreadyAttached.has(sheet.id)) {
                return false;
            }
            // Walk up to a sheet the company holds. seen[] stops a parent_id
            // cycle from hanging the page; the data should not contain one.
            const seen = new Set<string>();
            let current: Price | undefined = sheet;
            while (current && !seen.has(current.id)) {
                if (companySheetIds.has(current.id)) {
                    return true;
                }
                seen.add(current.id);
                current = current.parent_id ? byId.get(current.parent_id) : undefined;
            }
            return false;
        });
    };

    /**
     * A sheet's service name, whichever shape the sheet arrived in.
     *
     * The picker's catalogue is Price - service_id, no nested service - while
     * the company payload's rows carry service. Both reach the same row
     * renderer, so neither may be assumed.
     */
    serviceNameFor = (sheet: GroupPricingSet | PricingSet | Price): string => {
        const { services } = this.props;
        const nested = (sheet as GroupPricingSet | PricingSet)?.service?.name;
        if (nested) {
            return nested;
        }
        const serviceId = (sheet as Price)?.service_id;
        return services?.find((x) => x.id === serviceId)?.name ?? '';
    };

    sheetLabel = (sheet: GroupPricingSet | PricingSet | Price): string => {
        const serviceName = this.serviceNameFor(sheet);
        return serviceName ? `${serviceName}: ${sheet.name}` : sheet.name;
    };

    handleAttachGroupSheet = (event) => {
        event.preventDefault();

        const { match, companies } = this.props;
        const { groupPricingSetId, groupStartDate, groupEndDate } = this.state;
        const id = match.params.id;
        const payload = companies[id];

        if (!groupPricingSetId || !payload?.uuid) {
            return;
        }

        const sheet = this.props.prices?.find((x) => x.id === groupPricingSetId);
        const service = this.props.services?.find((x) => x.id === sheet?.service_id);
        const body: any = {
            pricing_set_id: groupPricingSetId,
            group_id: payload.uuid,
        };
        // Sent only when set: the API defaults start_date to now, and an empty
        // string is not a date.
        if (groupStartDate) {
            body.start_date = groupStartDate;
        }
        if (groupEndDate) {
            body.end_date = groupEndDate;
        }

        this.props.createGroupToPricingSets(id, sheet && { ...sheet, service }, body, () => {
            this.setState({ groupPricingSetId: '', groupStartDate: '', groupEndDate: '' });
        });
    };

    handleAddExtraSubmit = (event) => {
        event.preventDefault();

        const { match, companies } = this.props;
        const id = match.params.id;
        const { extra } = this.state;
        const company = companies[id];

        this.props.createCompanyToExtras(company, { extra_id: extra, company_id: company.uuid }, () => {
            this.setState({
                extra: '',
            });
        });
    };

    // Autocomplete
    handleBanDriverFromCompanySubmit = (event) => {
        event.preventDefault();
        const { match, companies } = this.props;
        const { idc } = this.state;
        const id = match.params.id;
        const payload = companies[id];

        //Check if idc (driver id) is set and that it doesn't exist already
        if (idc > 0 && payload.banDrivers.findIndex((x) => x.driver?.id === idc) === -1) {
            this.props.banDriverFromCompany(id, idc, () => {
                this.autofillRef.reset();
                this.setState({
                    text: '',
                });
            });
        }
    };

    handleUnbanDriverFromCompany = (idc, idb) => (event) => {
        event.preventDefault();
        const id = this.props.match.params.id;
        if (idb > 0) {
            this.props.unbanDriverFromCompany(id, idc, idb);
        }
    };

    handleSMSConfSubmit = (event) => {
        event.preventDefault();
        const { formSms } = this.state;
        const id = this.props.match.params.id;
        const payload = {
            reservation_sms: !formSms.disabled,
        };
        this.props.editCompany(id, payload);
    };

    handleSubcontractConfSubmit = (event) => {
        event.preventDefault();
        const { formSubcontract } = this.state;
        const id = this.props.match.params.id;
        // Only this key: the webservice logs who changed it in the company history
        this.props.editCompany(id, { subcontract_hide_rider: formSubcontract.hideRider });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { formData } = this.state;
        const id = this.props.match.params.id;

        const payload_groups = formData.dispatchGroups
            .filter((group) => group.isEnabled)
            .map((group) => ({
                name: group.name,
                id: group.id,
                value: group.isAuthorized,
            }));

        this.props.editCompanyDispatchGroups(
            id,
            {
                the_dispatch_groups: payload_groups,
                the_dispatch_groups_bo: formData.dispatchGroups.map((group) => ({
                    name: group.name,
                    id: group.id,
                    value: group.isEnabled,
                })),
            },
            () => {
                formData.initialDispatchGroups = JSON.parse(JSON.stringify(formData.dispatchGroups));
                this.setState({ formData });
            },
        );
    };

    loaderObserver(flags, row, id) {
        if (flags.companies?.[row.company.id]?.riders?.[row.rider.id]?.loader?.[id]?.loading) {
            return <MainLoading center size={24} />;
        }
        return null;
    }

    headerDepartmentBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            createCell(t, Cell.NAME),
            createCell(t, Cell.CREATION_DATE),
            {
                id: 'total_net_price_without_vat_generated_recently',
                label: t('total_net_30'),
                filterable: false,
                type: FormatType.Price,
            },
            {
                id: 'total_net_price_without_vat',
                label: t('total_net'),
                filterable: false,
                type: FormatType.Price,
            },
            { id: 'nb_users', label: t('nb_users'), filterable: false },
        ];
        return headers;
    };

    headerMembershipBuilder = (payload: Company): HeadCell[] => {
        const { t } = this.props;
        const { formData } = this.state;

        this.departmentOptions = [{ value: '', label: '' }];
        if (payload.departments) {
            payload.departments.forEach((d) => {
                this.departmentOptions.push({
                    value: d.id,
                    label: `${d.name}${d.deletion_date ? ` (${t('common:suspended')})` : ''} (${d.id})`,
                });
            });
        }

        const headers: HeadCell[] = [
            { id: 'rider.id', label: t('common:form.id'), contains: false },
            { id: 'rider.fullname', label: t('common:form.lastname') },
            { id: 'rider.email', label: t('common:form.email') },
            { id: 'rider.phone_number', label: t('common:form.phone_number'), type: FormatType.Phone },
            {
                id: 'status',
                label: t('memberships.status'),
                type: FormatType.Picker,
                disabled: !this.canWriteSettings,
                action: this.handleUserUpdate.bind(this, 'status'),
                pickerOptions: this.statusOptions,
                loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            },
            {
                id: 'rider_dispatch_groups_authorizations',
                label: t('dispatch_groups'),
                filterable: false,
                type: FormatType.Chips,
                disabled: !this.canWriteSettings,
                action: this.handleUserUpdate.bind(this, 'rider_dispatch_groups_authorizations'),
                chipsOptions: formData.dispatchGroups && formData.dispatchGroups.filter((dg) => dg.isAuthorized),
                chipsTest: (row, val, option) => {
                    const index = val.findIndex((m) => m.dispatch_group.id === option.id);
                    const activated = index !== -1 ? val[index].authorization_status : true;
                    return activated;
                },
                formatCell: (row) => {
                    return row.rider?.rider_dispatch_groups_authorizations ?? '';
                },
                loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            },
            {
                id: 'rider.total_net_price_without_vat_generated_recently',
                label: t('total_net_30'),
                filterable: false,
                type: FormatType.Price,
            },
            {
                id: 'rider.total_net_price_without_vat',
                label: t('total_net'),
                filterable: false,
                type: FormatType.Price,
            },
            {
                id: 'admin',
                label: t('memberships.admin'),
                type: FormatType.Boolean,
                disabled: !this.canWriteSettings,
                action: this.handleUserUpdate.bind(this, 'admin'),
                loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            },
            {
                id: 'accountant',
                label: t('memberships.accountant'),
                type: FormatType.Boolean,
                disabled: !this.canWriteSettings,
                action: this.handleUserUpdate.bind(this, 'accountant'),
                loaderCell: null /* (row, id) => this.loaderObserver(flags, row, id),*/,
            },
        ];

        // Add department column only when no parents
        if (!payload.parent) {
            headers.push({
                id: 'department.id',
                label: t('memberships.department'),
                type: FormatType.Picker,
                disabled: !this.canWriteSettings,
                action: this.handleUserUpdate.bind(this, 'department_id'),
                pickerOptions: this.departmentOptions,
                loaderCell: null /*(row, id) => this.loaderObserver(flags, row, id),*/,
            });
        }
        return headers;
    };

    headerContractBuilder = (): HeadCell[] => {
        const { t, globalClasses, match } = this.props;
        const id = match.params.id;

        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { filterable: false }),
            createCell(t, Cell.CREATION_DATE),
            {
                id: 'current_version.state',
                label: t('memberships.status'),
                filterable: false,
                type: FormatType.Picker,
                disabled: !this.canWriteSettings,
                action: this.handleContractUpdate,
                pickerOptions: this.contactStatusOptions,
            },
            {
                id: 'current_version.start_date',
                label: t('contracts.start_date'),
                type: FormatType.DateShort,
                filterable: false,
            },
            {
                id: 'current_version.end_date',
                label: t('contracts.end_date'),
                type: FormatType.DateShort,
                filterable: false,
            },
            {
                id: 'status',
                label: t('contracts.file'),
                filterable: false,
                formatCell: (row) => {
                    const { current_version } = row;
                    return (
                        <TooltipButton title={t('common:download')}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                href={generateDocumentUrl(current_version.id)}
                                target="_blank"
                                rel="noreferrer noopener"
                                style={{ minWidth: 'auto', paddingLeft: 4, paddingRight: 4 }}
                                className={globalClasses.btnAutoWidth}
                            >
                                <GetAppIcon />
                            </Button>
                        </TooltipButton>
                    );
                },
            },
        ];

        if (this.canWriteSettings) {
            headers.push({
                id: 'action',
                label: t('common:action'),
                filterable: false,
                formatCell: (row) => {
                    return (
                        <div>
                            <TooltipButton title={t('common:edit')}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginRight: 8 }}
                                    component={RouterLink}
                                    to={createPath(paths.companiesContractEdit, { id, idc: row.current_version.id })}
                                    className={clsx(globalClasses.btnAutoWidth, globalClasses.btnEdit)}
                                >
                                    <Icon fontSize="small">edit</Icon>
                                </Button>
                            </TooltipButton>
                            <Dialog
                                btnTitle={t('common:validate')}
                                description={t('common:deleteParam', { id: row.id })}
                                customButton={
                                    <TooltipButton title={t('common:delete')}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                        >
                                            <Icon fontSize="small">close</Icon>
                                        </Button>
                                    </TooltipButton>
                                }
                                onOK={this.handleAction(row, companyTypes.DELETE_COMPANY_CONTRACT)}
                            />
                        </div>
                    );
                },
            });
        }

        return headers;
    };

    renderCourseTypeView = (): JSX.Element[] => {
        const { formData } = this.state;
        if (formData?.dispatchGroups) {
            return formData.dispatchGroups
                .filter((group) => group.isEnabled)
                .map((group, key) => (
                    <FormControlLabel
                        key={`${group.id}-${key}`}
                        style={{ marginLeft: 8 }}
                        disabled={!this.canWriteSettings}
                        control={
                            <Checkbox
                                checked={group.isAuthorized}
                                value={group.id}
                                onChange={() => {
                                    const updatedGroups = [...formData.dispatchGroups];
                                    const index = updatedGroups.findIndex((g) => g.id === group.id);
                                    updatedGroups[index] = {
                                        ...updatedGroups[index],
                                        isAuthorized: !updatedGroups[index].isAuthorized,
                                    };
                                    this.setState({
                                        formData: { ...formData, dispatchGroups: updatedGroups },
                                    });
                                }}
                            />
                        }
                        label={group.name}
                    />
                ));
        }
        return null;
    };

    //TODO: quand on réactive il faudrait rajouter les nouveaux
    renderCourseTypeBoView = (): JSX.Element[] => {
        const { formData } = this.state;
        if (formData?.dispatchGroups) {
            return formData.dispatchGroups.map((group, key) => (
                <FormControlLabel
                    key={`${group.id}-${key}`}
                    style={{ marginLeft: 8 }}
                    control={
                        <Checkbox
                            checked={group.isEnabled}
                            value={group.id}
                            onChange={() => {
                                const updatedGroups = [...formData.dispatchGroups];
                                const index = updatedGroups.findIndex((g) => g.id === group.id);
                                updatedGroups[index] = {
                                    ...updatedGroups[index],
                                    isEnabled: !updatedGroups[index].isEnabled,
                                };
                                this.setState({
                                    formData: { ...formData, dispatchGroups: updatedGroups },
                                });
                            }}
                        />
                    }
                    label={group.name}
                />
            ));
        }
        return null;
    };

    listItemBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        const items: ListCell[] = [
            { title: t('common:form.lastname'), data: payload.name },
            { title: t('common:form.id'), data: payload.id, readOnly: true },
            {
                title: t('creation_date'),
                readOnly: true,
                data: payload.creation_date,
                type: FormatType.DateShort,
            },
            {
                title: t('activation_date'),
                data: payload.activation_date,
                optional: true,
                type: FormatType.DateShort,
            },
            {
                title: t('parent'),
                readOnly: true,
                data: payload.parent && (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={createPath(paths.companiesDetails, { id: payload.parent.id })}
                    >
                        {payload.parent.name}
                    </Link>
                ),
                optional: true,
            },
            { title: t('siren'), data: payload.siren },
            { title: t('nb_users'), readOnly: true, data: payload.nb_users },
            {
                title: t('avg_price_booking'),
                readOnly: true,
                data: payload.nb_bookings > 0 ? payload.total_net_price_without_vat / payload.nb_bookings : '-',
                type: FormatType.Price,
            },
            {
                title: t('total_net_30'),
                readOnly: true,
                data: payload.total_net_price_without_vat_generated_recently,
                type: FormatType.Price,
            },
            {
                title: t('total_net'),
                readOnly: true,
                data: payload.total_net_price_without_vat,
                type: FormatType.Price,
            },
            {
                title: t('nb_bookings'),
                readOnly: true,
                data:
                    payload.nb_bookings > 0 ? (
                        <MyLink color="secondary" to={`${paths.bookings}?filters[company.id]=${payload.id}`}>{`${
                            payload.nb_bookings
                        } (${t('common:click_to_see')})`}</MyLink>
                    ) : (
                        payload.nb_bookings
                    ),
                optional: true,
            },
            {
                title: t('account_manager'),
                readOnly: true,
                optional: true,
                data: payload.account_manager?.name,
            },
            {
                title: t('industry'),
                readOnly: true,
                optional: true,
                data: payload.industry?.name,
            },
            {
                title: '',
                data: '',
                emptyCell: true,
            },
            {
                title: t('simple_invoice'),
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.billsSimple}?filters[company_id]=${payload.uuid}`}
                    >
                        {t('common:click_to_see')}
                    </Link>
                ),
            },
            {
                title: t('mensual_invoice'),
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.billsPeriods}?filters[company_id]=${payload.uuid}`}
                    >
                        {t('common:click_to_see')}
                    </Link>
                ),
            },
            {
                title: t('refound'),
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.billsCreditNotes}?filters[company_id]=${payload.uuid}`}
                    >
                        {t('common:click_to_see')}
                    </Link>
                ),
            },
            {
                title: t('refound_month'),
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.billsMonthCreditNotes}?filters[company_id]=${payload.uuid}`}
                    >
                        {t('common:click_to_see')}
                    </Link>
                ),
            },
        ];

        return items;
    };

    listItemBillingBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        return [
            {
                title: t('corporate_name'),
                data: payload.corporate_name,
                optional: true,
            },
            {
                title: t('contract_number'),
                data: payload.contract_number,
                optional: true,
            },
            { title: t('purchase_order'), data: payload.purchase_order },
            { title: t('vat_number'), data: payload.vat_number },
            {
                title: t('billing_address'),
                data: payload.billing_address,
                type: FormatType.Address,
            },
            {
                title: t('billing_cost_center'),
                data: payload.recipient_type === 'cost_center',
                type: FormatType.Boolean,
            },
            {
                title: t('accountants'),
                data: (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                        }}
                    >
                        {payload.accountants?.map((a, index) => {
                            return (
                                <div key={`${a.id}-${index}`}>
                                    <Link
                                        color="secondary"
                                        key={a.id}
                                        component={RouterLink}
                                        to={createPath(paths.ridersDetails, { id: a.id })}
                                    >
                                        {StringUtils.userFullname(a as any)}
                                    </Link>
                                    <span>
                                        {' '}
                                        ({a.email} - {a.phone_number})
                                    </span>
                                </div>
                            );
                        })}

                        {payload.billing_emails &&
                            payload.billing_emails.length > 0 &&
                            payload.billing_emails.split(';').map((mail, index) => {
                                return (
                                    <div key={`${mail}-${index}`}>
                                        <span>{mail}</span>
                                    </div>
                                );
                            })}
                    </div>
                ),
                optional: true,
            },
            {
                title: t('send_bill_export'),
                data: payload.send_bill_export,
                type: FormatType.Boolean,
            },
        ];
    };

    renderGroupSheetRow = (
        sheet: GroupPricingSet | PricingSet,
        inherited: boolean,
        parentName?: string,
        groupUuid?: string,
        companyRouteId?: string,
    ) => {
        const { t, globalClasses } = this.props;
        const linkId = (sheet as GroupPricingSet).group_to_pricing_set_id;

        return (
            <div
                key={`${inherited ? 'inherited' : 'own'}-${sheet.id}`}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px',
                    borderRadius: '4px',
                    backgroundColor: inherited ? '#fafafa' : '#f5f5f5',
                }}
            >
                <span style={{ flex: 1 }}>
                    {this.sheetLabel(sheet)}
                    <em style={{ marginLeft: 8, color: '#757575' }}>
                        {inherited ? t('group_pricing.inherited_from', { name: parentName }) : t('group_pricing.own')}
                    </em>
                </span>

                <div style={{ display: 'flex', gap: '8px' }}>
                    {inherited && this.canCreateGroupSheet && groupUuid && (
                        <TooltipButton title={t('group_pricing.create_override')}>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                component={RouterLink}
                                to={`${paths.pricingManagePricesAdd}?parent_id=${sheet.id}&group_id=${groupUuid}&company_id=${companyRouteId}&service_id=${sheet.service?.id ?? ''}`}
                                className={globalClasses.btnAutoWidth}
                            >
                                <Icon fontSize="small">add</Icon>
                            </Button>
                        </TooltipButton>
                    )}

                    <TooltipButton title={t('common:view')}>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            component={RouterLink}
                            to={createPath(paths.pricingManagePricesDetails, { id: sheet.id })}
                            className={globalClasses.btnAutoWidth}
                        >
                            <Icon fontSize="small">visibility</Icon>
                        </Button>
                    </TooltipButton>

                    {/* Only the group's own link can be detached here. Removing an
                        inherited sheet would detach it from the whole company. */}
                    {!inherited && this.canWritePricing && (
                        <Dialog
                            btnTitle={t('common:validate')}
                            description={t('group_pricing.detach_confirm', { name: sheet.name })}
                            customButton={
                                <TooltipButton title={t('common:delete')}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                    >
                                        <Icon fontSize="small">delete</Icon>
                                    </Button>
                                </TooltipButton>
                            }
                            onOK={this.handleAction(
                                { id: sheet.id, group_to_pricing_set_id: linkId },
                                pricingTypes.DELETE_GROUP_PRICING_SET,
                            )}
                        />
                    )}
                </div>
            </div>
        );
    };

    // Contract: _platform/docs/features/pricing-per-group.md
    /**
     * A departement's tariffs: what it overrides, and what it inherits.
     *
     * Own and inherited are shown together on purpose. A group sheet is a child
     * of the company's, so it overrides only the parameters it defines and the
     * company sheet above it still supplies the rest - showing one without the
     * other misrepresents what the departement is actually priced on.
     */
    renderGroupPricingSets = (payload: Company) => {
        const { t, globalClasses, updateGroupPricingSetsError } = this.props;
        const { groupPricingSetId, groupStartDate, groupEndDate } = this.state;

        const own = payload.group_pricing_sets ?? [];
        const inherited = payload.pricing_sets ?? [];
        const parentName = payload.parent?.name;
        const candidates = this.groupSheetCandidates(payload);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {/* "Could not be loaded" and "has none of its own" are different
                    answers, and the second is the normal one. */}
                {payload.group_pricing_sets_failed && (
                    <ErrorMessage payload={{ message: t('group_pricing.load_failed') }} />
                )}

                {this.canWritePricing && (
                    <FormSubmit debounceSubmit={{ callback: this.handleAttachGroupSheet }}>
                        <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap', gap: 8 }}>
                            <FormControl key="formGroupSheet" margin="dense" style={{ minWidth: 240 }}>
                                <FormLabel>{t('group_pricing.attach')}</FormLabel>
                                <Select
                                    native
                                    id="group_pricing_set"
                                    name="group_pricing_set"
                                    value={groupPricingSetId}
                                    required
                                    onChange={(e) => this.setState({ groupPricingSetId: e.target.value as string })}
                                >
                                    <option key="empty" value="">
                                        {''}
                                    </option>
                                    {candidates.map((sheet) => (
                                        <option key={sheet.id} value={sheet.id}>
                                            {this.sheetLabel(sheet)}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Dates make a switch-over schedulable: a successor can
                                be attached before the current one ends. */}
                            <FormControl margin="dense">
                                <FormLabel>{t('group_pricing.start_date')}</FormLabel>
                                <input
                                    type="date"
                                    value={groupStartDate}
                                    onChange={(e) => this.setState({ groupStartDate: e.target.value })}
                                />
                            </FormControl>
                            <FormControl margin="dense">
                                <FormLabel>{t('group_pricing.end_date')}</FormLabel>
                                <input
                                    type="date"
                                    value={groupEndDate}
                                    onChange={(e) => this.setState({ groupEndDate: e.target.value })}
                                />
                            </FormControl>

                            <TooltipButton title={t('common:add')}>
                                <Button
                                    size="small"
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    className={globalClasses.btnAutoWidth}
                                >
                                    <Icon fontSize="small">add</Icon>
                                </Button>
                            </TooltipButton>
                        </div>
                    </FormSubmit>
                )}

                <ErrorMessage payload={updateGroupPricingSetsError} />

                {own.map((sheet) => this.renderGroupSheetRow(sheet, false))}
                {inherited.map((sheet) =>
                    this.renderGroupSheetRow(sheet, true, parentName, payload.uuid, this.props.match.params.id),
                )}

                {own.length === 0 && !payload.group_pricing_sets_failed && (
                    <em>
                        {inherited.length > 0
                            ? t('group_pricing.none_inherits_all', { name: parentName })
                            : t('group_pricing.none_at_all', { name: parentName })}
                    </em>
                )}
            </div>
        );
    };

    listItemFacturationBuilder = (payload: Company, isDepartment = false): ListCell[] => {
        const { t, globalClasses } = this.props;

        // A departement gets its own tariff item and nothing else: the
        // management fee below is negotiated once for the whole company.
        if (isDepartment) {
            return [
                {
                    title: t('pricing_sets'),
                    data: this.renderGroupPricingSets(payload),
                    optional: true,
                },
            ];
        }

        const items: ListCell[] = [
            {
                title: t('pricing_sets'),
                data: (
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                            }}
                        >
                            {this.canWritePricing && (
                                <div style={{ alignSelf: 'flex-start' }}>
                                    <TooltipButton title={t('common:add')}>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="secondary"
                                            component={RouterLink}
                                            to={paths.pricingManagePrices}
                                            className={globalClasses.btnAutoWidth}
                                        >
                                            <Icon fontSize="small">add</Icon>
                                        </Button>
                                    </TooltipButton>
                                </div>
                            )}

                            {payload.pricing_sets?.map((o, oid) => {
                                return (
                                    <div
                                        key={`${oid}-${o.id}`}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                        }}
                                    >
                                        <span style={{ flex: 1 }}>{`${o.service?.name}: ${o.name}`}</span>

                                        {this.canWritePricing && (
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <TooltipButton title={t('common:edit')}>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="primary"
                                                        component={RouterLink}
                                                        to={createPath(paths.pricingManagePricesDetails, {
                                                            id: o.id,
                                                        })}
                                                        className={globalClasses.btnAutoWidth}
                                                    >
                                                        <Icon fontSize="small">edit</Icon>
                                                    </Button>
                                                </TooltipButton>
                                                <Dialog
                                                    btnTitle={t('common:validate')}
                                                    description={t('common:deleteParam', { id: o.id })}
                                                    customButton={
                                                        <TooltipButton title={t('common:delete')}>
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                color="primary"
                                                                className={clsx(
                                                                    globalClasses.btnAutoWidth,
                                                                    globalClasses.btnDanger,
                                                                )}
                                                            >
                                                                <Icon fontSize="small">delete</Icon>
                                                            </Button>
                                                        </TooltipButton>
                                                    }
                                                    onOK={this.handleAction(o, pricingTypes.DELETE_COMPANY_PRICING_SET)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ),
                optional: true,
            },
            {
                title: t('management_fee'),
                data: payload.extras_list && (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                        }}
                    >
                        {this.canWritePricing && (
                            <FormSubmit debounceSubmit={{ callback: this.handleAddExtraSubmit }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControl key={'formExtras'} margin="dense">
                                        <Select
                                            native
                                            id={'extra'}
                                            name={'extra'}
                                            value={this.state.extra}
                                            required={true}
                                            onChange={(e) => {
                                                this.setState({
                                                    extra: e.target.value,
                                                });
                                            }}
                                        >
                                            <option key={'empty'} value={''}>
                                                {''}
                                            </option>
                                            {payload.extras_list
                                                .filter((e) => !payload.management_fee.find((x) => x.id === e.id))
                                                .map((select, i) => {
                                                    return (
                                                        <option key={`${select.id}-${i}`} value={select.id}>
                                                            {select.name}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                    <span>
                                        <TooltipButton title={t('common:add')}>
                                            <Button
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                color="secondary"
                                                className={globalClasses.btnAutoWidth}
                                            >
                                                <Icon fontSize="small">add</Icon>
                                            </Button>
                                        </TooltipButton>
                                    </span>
                                </div>
                            </FormSubmit>
                        )}

                        {payload.management_fee?.length > 0 &&
                            payload.management_fee.map((mf, i) => {
                                return (
                                    <div key={`${mf.id}-${i}`} style={{ margin: '8px 0px' }}>
                                        <span style={{ marginRight: 8 }}>{mf.name}</span>

                                        {this.canWritePricing && (
                                            <Dialog
                                                btnTitle={t('common:validate')}
                                                description={t('common:deleteParam', { id: mf.id })}
                                                customButton={
                                                    <TooltipButton title={t('common:delete')}>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            color="primary"
                                                            className={clsx(
                                                                globalClasses.btnAutoWidth,
                                                                globalClasses.btnDanger,
                                                            )}
                                                        >
                                                            <Icon fontSize="small">delete</Icon>
                                                        </Button>
                                                    </TooltipButton>
                                                }
                                                onOK={this.handleAction(mf, pricingTypes.DELETE_COMPANY_EXTRA)}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                ),
                optional: true,
            },
            // List of the billing_month_payments in the company + active or not
            // {
            //     title: t('centralized_payment_mode_details'),
            //     data:
            //         payload.centralized_payment === CompanyCentralizedPayment.central
            //             ? payload.billing_month_payments.map(
            //                   (bmp) => `${t('paiement.type.' + bmp.type)} - ${bmp.name} (${bmp.status})`,
            //               )
            //             : 'N/A',
            // },
        ];
        return items;
    };

    listItemPaiementBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        const defaultPayment = payload.default_billing_month_payments;
        const is_sepa: boolean =
            payload.centralized_payment_mode === CompanyCentralizedPaymentMode.mensual &&
            payload.centralized_mensual_payment_mode === CompanyMensualCentralizedPaymentMode.sepa;

        const { centralizedPaymentMode, centralizedMensualPaymentMode } = getPaymentModeDetails(payload, t);

        let items: ListCell[] = [
            {
                title: t('grouped_payment_allowed'),
                data: payload.grouped_payment_allowed,
                type: FormatType.Boolean,
            },
            {
                title: t('payment_policy'),
                data:
                    payload.centralized_payment === CompanyCentralizedPayment.central
                        ? t('paiement.central')
                        : t('paiement.individual'),
            },
            {
                title: t('centralized_payment_mode'),
                data: centralizedPaymentMode,
            },
            {
                title: t('centralized_mensual_payment_mode'),
                data: centralizedMensualPaymentMode,
            },
            {
                title: t('paiement.type.sepa'),
                data:
                    is_sepa &&
                    `${defaultPayment.sepa_holder_name}\n${FormattingUtils.format(
                        defaultPayment.sepa_signature_date,
                        FormatType.DateShort,
                        t,
                    )}\n${defaultPayment.sepa_iban}\n${defaultPayment.sepa_rum}`,
            },
            {
                title: t('common:docs.rib'),
                data: true,
                customValue: (
                    <InlineDocument
                        key={'vtc_license'}
                        {...this.generateDocuments(payload).find((d) => d.docType === 'rib')}
                        docClass="company"
                        classId={payload.id}
                        readOnly={!this.canWriteSettings}
                        noLabel={true}
                    />
                ),
            },
            {
                title: t('obp_webapp'),
                data: payload.obp_webapp,
                type: FormatType.Boolean,
            },
        ];

        if (!is_sepa) {
            items = items.filter((i) => i.title !== t('paiement.type.sepa'));
        }
        return items;
    };

    listItemTripBuilder = (payload: Company): ListCell[] => {
        const { t } = this.props;

        return [
            {
                title: t('book_for_others'),
                data: payload.book_for_others,
                type: FormatType.Boolean,
            },
            {
                title: t('default_booking_address'),
                data: payload.default_booking_address,
                type: FormatType.Address,
                readOnly: true,
                optional: true,
            },
            {
                title: t('default_cost_center'),
                data: getCostCenterDetails(payload.default_cost_center),
                optional: true,
            },
            {
                title: t('cost_center_mandatory'),
                data: payload.cost_center_mandatory,
                type: FormatType.Boolean,
            },
            {
                title: t('ride_reason_mandatory'),
                data: payload.ride_reason_mandatory,
                type: FormatType.Boolean,
            },
            {
                title: t('analytics_reference_enabled'),
                data: payload.analytics_reference_enabled,
                type: FormatType.Boolean,
            },
        ];
    };

    listItemRestrictionsBuilder = (payload: Company): ListCell[] => {
        const { t, zoom, center } = this.props;

        const sortingDaysArr = DateUtils.sortingDaysArr;

        if (!payload.travel_policies) {
            return [];
        }
        return [
            {
                title: t('trip_policy_restrictions.hours'),
                data:
                    payload.travel_policies?.time_slots &&
                    Object.entries(payload.travel_policies.time_slots)
                        .sort((a, b) => sortingDaysArr.indexOf(a[0]) - sortingDaysArr.indexOf(b[0]))
                        .map(([day, slots]: [string, Array<TravelPolicyTimeSlot>]) => {
                            return (
                                t('common:days.' + day) +
                                ': ' +
                                slots
                                    .map((s) => `${t('common:from')} ${s.start} ${t('common:hour_to')} ${s.end}`)
                                    .join(', ')
                            );
                        })
                        .join('\n'),
            },
            {
                title: t('trip_policy_restrictions.location'),
                optional: true,
                data:
                    payload.travel_policies?.areas &&
                    payload.travel_policies.areas
                        .map((a) => `${a.latitude} ${a.longitude} - radius ${a.radius}`)
                        .join('\n'),
                customValue: (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            {Object.entries(STOP_TYPE_COLOR).map((k, index) => {
                                return (
                                    <div
                                        key={`${index}-${k[1].label}`}
                                        style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}
                                    >
                                        <span
                                            style={{
                                                height: 10,
                                                width: 10,
                                                backgroundColor: k[1].fillColor,
                                                marginRight: 8,
                                            }}
                                        />
                                        {k[1].label}
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ height: '50vh', width: '100%' }}>
                            <GoogleMapReact
                                key={payload.uuid}
                                bootstrapURLKeys={{ key: envConfig.google_key }}
                                yesIWantToUseGoogleMapApiInternals
                                onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
                                defaultCenter={center}
                                defaultZoom={zoom}
                            />
                        </div>
                    </>
                ),
            },
        ];
    };

    generateDocuments = (payload: Company): DocumentType[] => {
        const { t } = this.props;

        const documents: DocumentType[] = [
            {
                id: payload.documents?.rib,
                name: t('common:docs.rib'),
                docType: 'rib',
            },
        ];
        return documents;
    };

    renderAdminDocuments = (payload: Company): JSX.Element => {
        const { t, classes } = this.props;
        if (payload && this.canWriteSettings) {
            const documents: DocumentType[] = this.generateDocuments(payload);
            return (
                <>
                    <br />
                    <Anchor id="documents" />
                    <Typobold>{t('common:form.documents')}</Typobold>
                    <div className={classes.docsCtn}>
                        {documents.map((doc, index) => (
                            <InlineDocument
                                key={doc.docType}
                                {...doc}
                                docClass="company"
                                readOnly={!this.canWriteSettings}
                                classId={payload.id}
                            />
                        ))}
                    </div>
                    <br />
                </>
            );
        }
        return null;
    };

    getActions = (id: string, payload: Company): any[] => {
        const { t } = this.props;
        const actions: any[] = [];
        const { uuid, parent } = payload || {};

        if (this.canExport) {
            // actions.push({
            //     label: t('actions.export_all_users'),
            //     func: () => this.props.exportCompanyUsers(id),
            // });
            // actions.push({
            //     label: t('actions.export_all_trips'),
            //     func: () => this.props.exportCompanyTrips(id),
            // });
            // actions.push({
            //     label: t('actions.export_trips'),
            //     customView: (
            //         <Dialog
            //             btnTitle={t('actions.export_trips')}
            //             description={t('actions.export_trips_description')}
            //             customButton={<div>{t('actions.export_trips')}</div>}
            //             formComponent={
            //                 <>
            //                     <FormControl key={'formStartDate'} style={{ display: 'flex' }}>
            //                         <div>{`${t('common:form.start_date')} *`}</div>
            //                         <Input type="date" name={'start_date'} required={true} />
            //                     </FormControl>
            //                     <FormControl key={'formEndDate'} style={{ display: 'flex' }}>
            //                         <div>{t('common:form.end_date')}</div>
            //                         <Input type="date" name={'end_date'} />
            //                     </FormControl>
            //                 </>
            //             }
            //             onOK={(fields) => {
            //                 let params = {
            //                     'filters[0][parameter]': 'creation_date',
            //                     'filters[0][type]': 'greater_than',
            //                     'filters[0][option][]': 'is_date',
            //                     'filters[0][value]': new Date(fields.start_date).getTime() / 1000,
            //                 };
            //                 if (fields.end_date) {
            //                     Object.assign(params, {
            //                         'filters[1][parameter]': 'creation_date',
            //                         'filters[1][type]': 'lower_or_equal_than',
            //                         'filters[1][option][]': 'is_date',
            //                         'filters[1][value]': new Date(fields.end_date).getTime() / 1000,
            //                     });
            //                 }
            //                 this.props.exportCompanyTrips(id, params);
            //             }}
            //         />
            //     ),
            // });
            if (
                envConfig.environment !== 'prod' ||
                ((forceBillingGroups.includes(`${parent?.id}`) || forceBillingGroups.includes(id)) && !!uuid)
            ) {
                actions.push({
                    label: t('actions.force_billing'),
                    func: () => this.setState({ dialogVisible: true }),
                });
            }
            actions.push({
                label: t('actions.export_report'),
                func: () => this.props.getCompanyReport(id),
            });
        }
        return actions;
    };

    renderEditButton = (id: string) => {
        const { t } = this.props;
        return (
            this.canWriteSettings && (
                <Button
                    color="secondary"
                    variant="contained"
                    component={RouterLink}
                    to={createPath(paths.companiesEdit, { id })}
                >
                    {t('common:edit')}
                </Button>
            )
        );
    };

    renderSMSConf = (payload: Company) => {
        const { t, classes } = this.props;
        const { formSms } = this.state;
        return (
            <FormSubmit debounceSubmit={{ callback: this.handleSMSConfSubmit }}>
                <Anchor id="sms_conf" />
                <Typobold>{t('communication.sms_conf.title')}</Typobold>
                <Card style={{ marginTop: 20 }} className={clsx(classes.card, classes.partnerInfo)}>
                    <CardContent>
                        <List>
                            <ListItem>
                                <FormLabel className={classes.partnerInfoLabel}>
                                    {t('communication.sms_conf.checkbox')}
                                </FormLabel>

                                <FormControlLabel
                                    style={{ marginLeft: 8 }}
                                    control={
                                        <Checkbox
                                            checked={formSms.disabled}
                                            value={'sms_disabled'}
                                            disabled={!this.canWriteSettings}
                                            onChange={() => {
                                                const tmpForm = Object.assign({}, formSms);
                                                tmpForm.disabled = !tmpForm.disabled;
                                                this.setState({ formSms: tmpForm });
                                            }}
                                        />
                                    }
                                    label=""
                                />
                            </ListItem>
                        </List>
                    </CardContent>
                    {this.canWriteSettings && (
                        <CardActions className={classes.rightActions}>
                            <Button
                                type="submit"
                                variant="contained"
                                color={payload.reservation_sms !== formSms.disabled ? 'inherit' : 'secondary'}
                            >
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    )}
                </Card>
            </FormSubmit>
        );
    };

    renderSubcontractConf = (payload: Company) => {
        const { t, classes } = this.props;
        const { formSubcontract } = this.state;
        // a department always follows its parent company, so the setting is only editable on the parent
        const editable = this.canWriteSettings && !payload.parent;
        return (
            <FormSubmit debounceSubmit={{ callback: this.handleSubcontractConfSubmit }}>
                <br />
                <Anchor id="subcontract_conf" />
                <Typobold>{t('communication.subcontract_conf.title')}</Typobold>
                <Card style={{ marginTop: 20 }} className={clsx(classes.card, classes.partnerInfo)}>
                    <CardContent>
                        <List>
                            <ListItem>
                                <FormLabel className={classes.partnerInfoLabel}>
                                    {t('communication.subcontract_conf.checkbox')}
                                </FormLabel>

                                <FormControlLabel
                                    style={{ marginLeft: 8 }}
                                    control={
                                        <Checkbox
                                            checked={formSubcontract.hideRider}
                                            value={'subcontract_hide_rider'}
                                            disabled={!editable}
                                            onChange={() => {
                                                this.setState({
                                                    formSubcontract: { hideRider: !formSubcontract.hideRider },
                                                });
                                            }}
                                        />
                                    }
                                    label=""
                                />
                            </ListItem>
                            <ListItem>
                                <FormHelperText>
                                    {payload.parent
                                        ? t('communication.subcontract_conf.inherited', { name: payload.parent.name })
                                        : t('communication.subcontract_conf.hint')}
                                </FormHelperText>
                            </ListItem>
                        </List>
                    </CardContent>
                    {editable && (
                        <CardActions className={classes.rightActions}>
                            <Button
                                type="submit"
                                variant="contained"
                                color={
                                    !!payload.subcontract_hide_rider === formSubcontract.hideRider
                                        ? 'inherit'
                                        : 'secondary'
                                }
                            >
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    )}
                </Card>
            </FormSubmit>
        );
    };

    generateTabs = (payload: Company): TabsDatas => {
        const { t, match, classes, isLoadingTravelPolicy } = this.props;
        const { formData } = this.state;
        const id = match.params.id;

        const isDepartment = payload.parent;

        const tabs: TabsDatas = {
            loadAll: true,
            datas: [
                {
                    label: t('tabs.general'),
                    children: (
                        <>
                            <EnhancedListItem
                                datas={this.listItemBuilder(payload)}
                                title={t('common:form.general_infos')}
                                cardActions={
                                    <>
                                        {this.renderEditButton(id)}
                                        {isDepartment && !payload.deletion_date && this.canWriteSettings && (
                                            <Dialog
                                                btnTitle={t('common:suspend')}
                                                description={`${t('common:suspendParam', {
                                                    id: payload.id,
                                                })} ${t('suspend_infos', {
                                                    dept: payload.name,
                                                    parent: payload.parent.name,
                                                })}`}
                                                customButton={
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        variant="contained"
                                                        aria-label="action"
                                                    >
                                                        {t('common:suspend')}
                                                    </Button>
                                                }
                                                onOK={(fields) =>
                                                    this.handleDeleteCompany(payload.id, payload.parent.id)
                                                }
                                            />
                                        )}
                                    </>
                                }
                            />
                            <Comment entity={EntityName.COMPANIES} entityId={id} />
                            <br />
                            <Anchor id="contracts" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableContractsRef = ref)}
                                title={t('contracts.title')}
                                headers={this.headerContractBuilder()}
                                type={this.tableRequestPoints.COMPANIES_CONTRACTS}
                                add={this.canWriteSettings && createPath(paths.companiesContractsAdd, { id })}
                            />
                            <br />
                            <ActionLogs history={payload.history} withValues />
                        </>
                    ),
                },
                {
                    label: t('departments'),
                    children: (
                        <>
                            <Anchor id="departments" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableDepartmentsRef = ref)}
                                title={t('departments')}
                                headers={this.headerDepartmentBuilder()}
                                type={this.tableRequestPoints.COMPANIES_DEPARTMENTS}
                                add={this.canWriteSettings && createPath(paths.companiesDepartmentsAdd, { id })}
                            />
                        </>
                    ),
                },
                {
                    label: t('memberships.title'),
                    children: (
                        <>
                            <Anchor id="memberships" />
                            <EnhancedTable
                                onRef={(ref) => (this.tableMembersRef = ref)}
                                title={t('memberships.title')}
                                headers={this.headerMembershipBuilder(payload)}
                                type={this.tableRequestPoints.COMPANIES_MEMBERSHIPS}
                                add={this.canWriteSettings && createPath(paths.companiesMembershipsAdd, { id })}
                            />
                        </>
                    ),
                },
                {
                    label: t('tabs.reservation'),
                    children: (
                        <>
                            <EnhancedListItem
                                datas={this.listItemTripBuilder(payload)}
                                title={t('trip_policy')}
                                cardActions={this.renderEditButton(id)}
                            />
                            <br />
                            <EnhancedListItem
                                datas={this.listItemRestrictionsBuilder(payload)}
                                title={t('trip_policy_restrictions.title')}
                                loader={isLoadingTravelPolicy && <MainLoading center />}
                                cardActions={
                                    this.canWriteSettings && (
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            component={RouterLink}
                                            to={createPath(paths.companiesRestrictions, { id })}
                                        >
                                            {t('trip_policy_restrictions.action')}
                                        </Button>
                                    )
                                }
                            />
                            <br />

                            {formData.id && (
                                <FormSubmit debounceSubmit={{ callback: this.handleSubmit }}>
                                    <Anchor id="additional_infos" />
                                    <Typobold>{t('course_type_info')}</Typobold>

                                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                                        <CardContent>
                                            <List disablePadding>
                                                {this.canWriteSettings && (
                                                    <ListItem divider>
                                                        <FormControl fullWidth margin="normal">
                                                            <FormLabel className={classes.partnerInfoLabel}>
                                                                {t('course_type_info_bo')}
                                                            </FormLabel>
                                                            <FormGroup row style={{ marginTop: 8 }}>
                                                                {this.renderCourseTypeBoView()}
                                                            </FormGroup>
                                                        </FormControl>
                                                    </ListItem>
                                                )}

                                                <ListItem>
                                                    <FormControl fullWidth margin="normal">
                                                        <FormLabel className={classes.partnerInfoLabel}>
                                                            {t('course_type_info')}
                                                        </FormLabel>
                                                        <FormGroup row style={{ marginTop: 8 }}>
                                                            {this.renderCourseTypeView()}
                                                        </FormGroup>
                                                    </FormControl>
                                                </ListItem>
                                            </List>
                                        </CardContent>

                                        {this.canWriteSettings && (
                                            <CardActions style={{ justifyContent: 'flex-end', padding: 16 }}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color={
                                                        ObjectUtils.isEqual(
                                                            formData.initialDispatchGroups,
                                                            formData.dispatchGroups,
                                                        )
                                                            ? 'inherit'
                                                            : 'secondary'
                                                    }
                                                >
                                                    {t('common:validate')}
                                                </Button>
                                            </CardActions>
                                        )}
                                    </Card>
                                </FormSubmit>
                            )}
                            <br />
                            {/* <form onSubmit={this.handleBanDriverFromCompanySubmit}>
                                <Typobold>{t('driver_ban')}</Typobold>
                                <Card style={{ marginTop: 20 }} className={clsx(classes.card, classes.partnerInfo)}>
                                    <CardContent>
                                        <List>
                                            <ListItem style={{ textAlign: 'center', flex: 1 }}>
                                                <AutoFill
                                                    onRef={(ref) => (this.autofillRef = ref)}
                                                    datas={{
                                                        id: 'driver_ban',
                                                        label: t('driver_to_ban'),
                                                        minChar: 1,
                                                        style: { flex: 1 },
                                                        formData: this.state,
                                                        filter: {
                                                            existingList: payload?.banDrivers.map((x) => x.driver.id),
                                                            test: (list, element) => !list.includes(element.id),
                                                        },
                                                        onChange: (idc, text) => {
                                                            this.setState({ idc, text });
                                                        },
                                                        loaderPosition: 'right',
                                                        api: getListDriversURL(),
                                                    }}
                                                />
                                            </ListItem>

                                            {payload?.banDrivers?.length > 0 && (
                                                <>
                                                    <p style={{ fontWeight: 'bold' }}>{t('driver_banned')}</p>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            flexWrap: 'wrap',
                                                        }}
                                                    >
                                                        {payload.banDrivers.map((info, index) => {
                                                            return (
                                                                <div
                                                                    key={`${info.driver?.id}-${index}`}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    <div>
                                                                        {StringUtils.userFullname(info.driver)}
                                                                    </div>
                                                                    <TooltipButton
                                                                        title={t('driver_unban', {
                                                                            driver: StringUtils.userFullname(info.driver),
                                                                        })}
                                                                        icon={
                                                                            <Icon color="error" fontSize="small">
                                                                                close
                                                                            </Icon>
                                                                        }
                                                                        style={{ marginRight: 0 }}
                                                                        onClick={this.handleUnbanDriverFromCompany(
                                                                            info.driver?.id,
                                                                            info.id,
                                                                        )}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                            )}
                                        </List>
                                    </CardContent>
                                    <CardActions className={classes.rightActions}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color={text.length === 0 && idc !== -1 ? 'inherit' : 'secondary'}
                                        >
                                            {t('common:validate')}
                                        </Button>
                                    </CardActions>
                                </Card>
                            </form> */}
                        </>
                    ),
                },
                {
                    label: t('tabs.pricing_billing'),
                    children: (
                        <>
                            <EnhancedListItem
                                datas={this.listItemBillingBuilder(payload)}
                                title={t('billing_infos')}
                                cardActions={this.renderEditButton(id)}
                            />
                            <EnhancedListItem
                                datas={this.listItemPaiementBuilder(payload)}
                                title={t('paiement.title')}
                                cardActions={this.renderEditButton(id)}
                            />
                            {this.canReadPricing && (
                                <EnhancedListItem
                                    datas={this.listItemFacturationBuilder(payload, !!isDepartment)}
                                    title={t('tarification')}
                                />
                            )}
                        </>
                    ),
                },
                {
                    label: t('tabs.communication'),
                    children: (
                        <>
                            {this.renderSMSConf(payload)}
                            {this.renderSubcontractConf(payload)}
                            <FidForm company={payload} rightCheck={AccountRight.COMPANY_FID_PROGRAM} />
                        </>
                    ),
                },
            ],
        };

        if (isDepartment) {
            tabs.datas.splice(1, 1);
        }
        return tabs;
    };

    render() {
        const { t, match, companies, globalClasses, getCompanyError, getTravelPoliciesError, getIndustriesError } =
            this.props;
        const { dialogVisible } = this.state;
        const id = match.params.id;
        const payload = companies[id];

        return (
            <App
                needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.R }}
                loading={!payload}
                loadingError={this.props.getCompanyError}
                onRetry={this.load}
                header={{
                    icon: 'default',
                    title: payload?.name,
                    subtitle: payload && `ID: ${payload.id}`,
                    bubble: {
                        visible: payload?.deletion_date,
                        text: t('common:suspended'),
                    },
                    actions: this.getActions(id, payload),
                    anchors: [
                        { href: '#general_infos', label: t('common:form.general_infos') },
                        {
                            href: '#additional_infos',
                            label: t('common:form.additional_infos'),
                        },
                        { href: '#documents', label: t('common:form.documents') },
                        { href: '#departments', label: t('departments') },
                        { href: '#memberships', label: t('memberships.title') },
                        { href: '#contracts', label: t('contracts.title') },
                        { href: '#history', label: t('common:history') },
                    ],
                }}
            >
                <ErrorMessage payload={getCompanyError || getTravelPoliciesError || getIndustriesError} />
                <ErrorMessage payload={this.props.companyViewActionsError} />
                {payload && (
                    <div className={globalClasses.blockShadow} style={{ flex: 1, overflow: 'hidden' }}>
                        <FastTabs tabs={this.generateTabs(payload)} />
                        {dialogVisible && (
                            <Dialog
                                btnTitle={t('actions.force_billing')}
                                description={t('actions.force_billing_hint')}
                                onOK={() => {
                                    this.setState({ dialogVisible: false });
                                    this.props.forceBillRides(payload?.uuid);
                                }}
                                onKO={() => {
                                    this.setState({ dialogVisible: false });
                                }}
                                isOpen={true}
                            />
                        )}
                    </div>
                )}
            </App>
        );
    }
}

const CompanyViewPageWithStyleAndTranslation = withGlobalStyles(
    withStyles(styles)(withTranslation(['company', 'document', 'common'])(CompanyViewPage)),
);

const mapStateToProps = (state) => ({
    companies: companySelector.getCompanies(state),
    dispatchGroups: driversSelectors.sortedDispatchGroup(state),
    getCompanyError: errorSelectors.getCompanyError(state),
    companyViewActionsError: errorSelectors.companyViewActionsError(state),
    getIndustriesError: errorSelectors.getIndustriesError(state),
    getTravelPoliciesError: errorSelectors.getTravelPoliciesError(state),
    updateGroupPricingSetsError: errorSelectors.updateGroupPricingSetsError(state),
    isLoadingTravelPolicy: pendingSelectors.isLoadingTravelPolicy(state),
    prices: pricingSelectors.prices(state),
    services: pricingSelectors.services(state),
    //TODO : add more error
});

const mapDispatchToProps = {
    clearError: errorActions.clearError,
    getCompany: companyActions.getCompany,
    getDispatchGroups: driversActions.getDispatchGroups,
    getCompanyReport: companyActions.getCompanyReport,
    exportCompanyTrips: companyActions.exportCompanyTrips,
    exportCompanyUsers: companyActions.exportCompanyUsers,
    editCompany: companyActions.editCompany,
    editCompanyDispatchGroups: companyActions.editCompanyDispatchGroups,
    deleteCompany: companyActions.deleteCompany,
    editMember: companyActions.editMember,
    deleteContract: companyActions.deleteContract,
    banDriverFromCompany: companyActions.banDriverFromCompany,
    unbanDriverFromCompany: companyActions.unbanDriverFromCompany,
    getTravelPolicies: companyActions.getTravelPolicies,
    forceBillRides: companyActions.forceBillRides,
    getCompanyToPricingSets: pricingActions.getCompanyToPricingSets,
    deleteCompanyToPricingSets: pricingActions.deleteCompanyToPricingSets,
    getPricingSets: pricingActions.getPricingSets,
    getServices: pricingActions.getServices,
    createGroupToPricingSets: pricingActions.createGroupToPricingSets,
    deleteGroupToPricingSets: pricingActions.deleteGroupToPricingSets,
    getCompanyToExtras: pricingActions.getCompanyToExtras,
    createCompanyToExtras: pricingActions.createCompanyToExtras,
    deleteCompanyToExtras: pricingActions.deleteCompanyToExtras,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyViewPageWithStyleAndTranslation);
